/** @format */

// Using lib import to prevent circular error
import {
	selectBopisInventory,
	selectEcommInventory
} from 'libs/pdp/data-access-new/+state/src/lib/product-selection.selectors';

import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ISkuLocation } from '@shared/data-access/interfaces';
import { StoreService } from '@shared/utils/services';
// Using lib import to prevent circular error
import { setResolvedSkuInventory } from 'libs/pdp/data-access-new/+state/src/lib/product-selection.actions';
import { take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class AttributesResolvedSkuInventoryService {
	constructor(
		private store: Store,
		private storeService: StoreService
	) {}

	getEcommResolvedSkuInventoryFromState(skuPartNumber: number | string): ISkuLocation | null {
		let resolvedSkuEcommInventory: ISkuLocation;
		if (skuPartNumber) {
			this.store
				.select(selectEcommInventory)
				.pipe(take(5))
				.subscribe((ecommInventorySkus) => {
					if (ecommInventorySkus) {
						resolvedSkuEcommInventory = this.storeService.getSkuInventoryFromLocations(
							ecommInventorySkus,
							skuPartNumber
						);
					} else {
						resolvedSkuEcommInventory = null;
					}
				});
		}
		return resolvedSkuEcommInventory;
	}

	getBopisResolvedSkuInventoryFromState(skuPartNumber: number | string): ISkuLocation | null {
		let resolvedSkuBopisInventory: ISkuLocation;
		if (skuPartNumber) {
			this.store
				.select(selectBopisInventory)
				.pipe(take(1))
				.subscribe((bopisInventorySkus) => {
					if (bopisInventorySkus) {
						resolvedSkuBopisInventory = this.storeService.getSkuInventoryFromLocations(
							bopisInventorySkus,
							skuPartNumber
						);
					} else {
						resolvedSkuBopisInventory = null;
					}
				});
		}
		return resolvedSkuBopisInventory;
	}

	setResolvedSkuInventoryInState(skuPartNumber: number | string): void {
		const ecommInventory = this.getEcommResolvedSkuInventoryFromState(skuPartNumber);
		const bopisInventory = this.getBopisResolvedSkuInventoryFromState(skuPartNumber);

		let allInventory;

		if (ecommInventory || bopisInventory) {
			allInventory = { ecomm: ecommInventory, bopis: bopisInventory };
		} else {
			allInventory = null;
		}

		this.store.dispatch(
			setResolvedSkuInventory({
				resolvedSkuInventory: allInventory,
				wasUninitialized: ecommInventory === null && bopisInventory === null
			})
		);
	}
}
